<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="listFilenameFormat"
      single-expand
      :search="search"
      :loading="loading"
      item-key="callid"
      class="alignTableOnBackground ml-5 mr-5 elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon class="px-1" @click="deletedFilenameFormat(item)">
              <v-icon small v-on="on">mdi-delete-off</v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Vue from "vue";

export default {
  props: {
    search: String,
  },
  data: () => ({
    headers: [
      { text: "ID", value: "id", sortable: "false" },
      { text: "Nombre", value: "name", sortable: "true" },
      {
        text: "Formato de Etiqueta",
        value: "filename_format",
        sortable: "true",
      },
      { text: "", value: "actions", sortable: "false" },
    ],
  }),
  methods: {
    deletedFilenameFormat(item) {
      return item; //TODO Revisar si esta funcion se queda.
    },
  },
  computed: {
    ...mapGetters("filenameFormat", {
      listFilenameFormat: "filenameFormatTable",
    }), //Traemos los valores
  },
  created() {
    this.$store.dispatch("filenameFormat/getFilenameFormat");
  },
};
</script>

<style></style>
